import type { ImgHTMLAttributes } from 'react';
import { LOGO_DATA_URI } from './logoDataUri';

export type BrandLogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>;

/**
 * The approved Little Chef logo, embedded as a data URI so it renders
 * identically across every consumer's bundler (Vite, Next.js, Vitest/jsdom)
 * without depending on bundler-specific static-asset import behavior.
 */
export function BrandLogo(props: BrandLogoProps) {
  return <img src={LOGO_DATA_URI} alt="Little Chef" {...props} />;
}
